const SpeechUtil = {
    speak : (text) => {
        if ( 'speechSynthesis' in window ) {
            const utter = new window.SpeechSynthesisUtterance(text);
            window.speechSynthesis.cancel();
            window.speechSynthesis.speak(utter);
          } 
    }
}
export default SpeechUtil;